/** React rendering and imperative updates share SVG's translate-then-scale
 * order, which leaves the translation unscaled and prevents release jumps. */
export function panTransform(tx: number, ty: number, scale: number): string {
  return `translate(${tx}, ${ty}) scale(${scale})`
}

/**
 * G.setNativeProps extracts a matrix but also forwards its original props.
 * Android's inherited View transform setter requires an array, so forwarding
 * a string there crashes Fabric. Send only SVG's affine matrix on native.
 */
export function panNativeProps(tx: number, ty: number, scale: number, platform: string) {
  return platform === 'web'
    ? { transform: panTransform(tx, ty, scale) }
    : { matrix: [scale, 0, 0, scale, tx, ty] }
}
